import React, { type PropsWithChildren, useCallback } from 'react';

import { ErrorBoundary as CommonErrorBoundary } from '@atlassian/search-common/error-boundary';

import { logger } from '../../utils/logger';

const useLogException = () => {
	return useCallback(async (error: Error) => {
		logger.error({ error, functionName: 'useLogException' });
	}, []);
};

type ErrorBoundaryProps = {
	fallback?: React.ReactNode;
};

export const ErrorBoundary = (props: PropsWithChildren<ErrorBoundaryProps>): React.JSX.Element => {
	const onException = useLogException();

	return (
		<CommonErrorBoundary {...props} onException={onException}>
			{props.children}
		</CommonErrorBoundary>
	);
};
